/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Link from 'components/link';
import DateText from 'components/date-text';
import styles from './style.module.scss';

interface AboutUsMediaCoverageCardProps {
  title: string;
  link: string;
  logoSrc: string;
  imageSrc: string;
  date: string;
}

export default function AboutUsMediaCoverageCard({ title, link, logoSrc, imageSrc, date }: AboutUsMediaCoverageCardProps) {
  return (
    <article className={styles.component}>
      <Link href={link} className={styles['image-wrapper']} target="_blank">
        <img
          src={imageSrc || '/next/assets/images/agent-search/no-agent-photo.png'}
          alt={'Zoocasa Media Coverage'}
          style={{ width: '100%', height: '270px' }}
        />
      </Link>
      <div className={styles['text-section']}>
        <div className={styles.logo}>
          <img
            src={logoSrc}
            alt={'Zoocasa Media Coverage'}
          />
        </div>
        <Link href={link} target="_blank"><h3 className={styles.title}>{title}</h3></Link>
        <DateText date={date} template="MMMM D, YYYY" render={formattedDate => <p className={styles.date}>{formattedDate}</p>} />
      </div>
    </article>
  );
}
